// Tiny hash-based router. Routes:
//   #/             -> devotional listing (home)
//   #/blog/:slug   -> devotional entry

export type Route =
  | { name: 'blog' }
  | { name: 'blog-entry'; slug: string };

type Listener = (route: Route) => void;
const listeners = new Set<Listener>();

function parse(hash: string): Route {
  const h = hash.startsWith('#') ? hash.slice(1) : hash;
  const clean = h.startsWith('/') ? h.slice(1) : h;
  const parts = clean.split('/').filter(Boolean);
  if (parts[0] === 'blog' && parts[1]) return { name: 'blog-entry', slug: parts[1]! };
  return { name: 'blog' };
}

export function currentRoute(): Route {
  return parse(window.location.hash);
}

export function navigate(route: Route): void {
  let hash: string;
  switch (route.name) {
    case 'blog-entry': hash = `#/blog/${route.slug}`; break;
    default: hash = '#/';
  }
  if (window.location.hash === hash) emit();
  else window.location.hash = hash;
}

export function onRouteChange(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function emit(): void {
  const r = currentRoute();
  for (const l of listeners) l(r);
}

window.addEventListener('hashchange', emit);
